exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rounded-page-header.page-heading{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:15px;overflow:hidden;margin:20px 10px 12px!important;padding:0!important}.rounded-page-header.page-heading>.col-lg-6,.rounded-page-header.page-heading>.col-lg-12{width:100%;float:none;padding-left:0!important;padding-right:0!important}.rounded-page-header.page-heading>.col-lg-6>h2,.rounded-page-header.page-heading>.col-lg-12>h2,.rounded-page-header__content{margin:0;padding:12px 16px;width:100%;display:block;box-sizing:border-box;background:transparent}.rounded-page-header__content{min-height:64px;display:flex;align-items:center;border-bottom:1px solid rgba(0,0,0,.06)}.matches-header-text{display:inline-flex;align-items:baseline;gap:6px;min-width:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/tenders/sent.to.bid.management.component.css
// module id = 1244
// module chunks = 0